import { useRef, useEffect } from "react";
import { motion, useInView, useSpring, useTransform } from "framer-motion";
import StatItem from "./StatItem"; // Importar StatItem

export const CountingNumber = ({ value, prefix = "", suffix = "", animateOnView }: { value: number; prefix?: string; suffix?: string; animateOnView: boolean }) => {
  const spring = useSpring(0, { stiffness: 100, damping: 30 }); // Ajuste de stiffness e damping
  const display = useTransform(spring, (current) => {
    return `${prefix}${Math.round(current).toLocaleString()}${suffix}`;
  });

  useEffect(() => {
    if (animateOnView) {
      spring.set(value);
    } else {
      // Opcional: reiniciar a contagem se o elemento sair da visão
      // spring.set(0);
    }
  }, [spring, value, animateOnView]);

  return <motion.span>{display}</motion.span>;
};


const NumbersSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 }); // useInView para a seção inteira

  const stats = [
    { value: 2500, label: "Habilitações Emitidas", prefix: "+" },
    { value: 400, label: "Embarcações Regularizadas", prefix: "+" },
    { value: 7, label: "Anos de Atuação" },
    { value: 4, label: "Unidades no Brasil" },
  ];

  return (
    <section ref={ref} className="relative bg-background py-24 sm:py-32 overflow-hidden">
      {/* Grid Pattern Overlay */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            linear-gradient(to right, hsl(var(--primary)) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(var(--primary)) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
        }}
      />

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-primary">
            Os Números Falam.
          </h2>
        </motion.div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-20">
          {stats.map((stat, index) => (
            <StatItem key={stat.label} stat={stat} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NumbersSection;
